
import ITarefa from "@/interfaces/ITarefa";
import { defineComponent, PropType } from "vue";
import BoxVueVue from "./BoxVue.vue";
import CronometroForm from "./CronometroForm.vue";
import BoxVue from "./BoxVue.vue";

export default defineComponent({
  name: "TarefaVue",
  components: { CronometroForm, BoxVue },
  props: {
    tarefa: {
      type: Object as PropType<ITarefa>,
      requiered: true,
    },
  },
});
